import { Box, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import SalesTicketForm from "../SalesTicketForm/SalesTicketForm";
import { AuthContext } from "../../../../context/AuthContext";

const NewSalesTicketPage = () => {
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { ezorder, authToken } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const createSalesTicket = async (salesTicket) => {
    try {
      setLoading(true);

      // Will Throw Yup.ValidationError if Fail
      //   let validated = await quoteSchema.validate(quote);

      let response = await ezorder.post(
        `/sales-tickets`,
        { salesTicket },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log(response.data.salesTicket);
      if (response.status == 200 || response.status === 201) {
        openSnackMessage("success", "Saved");
        // navigate(`/consumables-pos/${response.data.salesTicket.id}`);
        navigate(`/consumables-pos/${response.data.salesTicket.id}`);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" textAlign="center">
        New Sales Ticket
      </Typography>
      <SalesTicketForm
        salesTicketId={null}
        onSave={(salesTicket) => {
          createSalesTicket(salesTicket);
        }}
        saving={loading}
        saveButtonTitle="Save Quote"
      />
    </Box>
  );
};

export default NewSalesTicketPage;
